module.exports = __webpack_public_path__ + "static/img/hotline.e96401a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hotline.png
// module id = Ml9F
// module chunks = 1 3 4 5 7 8 9 13 14 24 25 26